import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-delete-confirm-modal',
  templateUrl: './delete-confirm-modal.component.html',
  styleUrls: ['./delete-confirm-modal.component.scss']
})
export class DeleteConfirmModalComponent {
  @Input() title: string = 'You are about to delete';
  @Input() message: string = 'Are you sure you want to delete this item?';
  @Input() confirmText: string = 'Delete';
  @Input() cancelText: string = 'Cancel';
  @Input() iconClass: string = 'fa fa-trash';
  @Input() deleteLoading: boolean = false;
  @Input() iconSrc: string = '../../../../../assets/images/delete.svg';
  @Input() bookingCount: number = 0;

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  onConfirm() {
    this.confirm.emit();
  }

  onCancel() {
    this.cancel.emit();
  }
} 